import React from "react";

import { useLoginWithRedirect } from "../../../utils/useLoginWithRedirect";

export const NavBarLoginButton: React.FC = () => {
  const loginWithRedirect = useLoginWithRedirect();
  const handleClick = () => {
    const redirectParams = {
      // Preserve query params (show_editor, view_as_super_admin, tab/slicer state, …)
      // across the login round-trip.
      url: window.location.pathname + window.location.search,
    };
    loginWithRedirect(redirectParams);
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex items-center justify-center px-4 py-[7px] rounded-[12px] text-[13px] font-semibold leading-[18px] text-primary-button-background cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity"
    >
      Log in
    </button>
  );
};
